import { Component } from '@angular/core';

@Component({
	selector: 'evasys-selector-primary',
	templateUrl: './selector-primary.component.html',
	styles: [':host {display: flex}'],
})
export class SelectorPrimaryComponent {}
